import { useContent } from "contexts/contentContext/contentContext.js";
import React from "react";
import { contains_heb } from "utils/hebrewOrArabicText.js";
import parse from "html-react-parser";
import Image from "components/Elements/Image/Image.tsx";

const FormPreviewSide = ({
  pageMode,
  viewType,
  selectedForm,
  closePreviewDesktop,
  titleForm,
  descriptionForm,
  formImage,
  demoPageId,
}) => {
  const { getTextByKey } = useContent();

  return (
    <>
      {viewType === "desktop" && closePreviewDesktop ? (
        <div className="preview-mode-class">
          <div className="form-image">
            <Image src={formImage} alt="" title="" />
          </div>
          <div className="description-preivew-desktop">
            {titleForm && (
              <h2
                style={{ direction: contains_heb(titleForm) }}
                className={`${
                  titleForm.length > 26
                    ? "above26"
                    : titleForm.length > 15
                    ? "above20"
                    : titleForm.length > 12
                    ? "above15"
                    : titleForm.length > 10
                    ? "above10"
                    : ""
                }`}
              >
                {demoPageId > 0
                  ? getTextByKey("default-title")
                  : parse(titleForm)}
              </h2>
            )}
            <p style={{ direction: contains_heb(descriptionForm) }}>
              {demoPageId > 0
                ? getTextByKey("default-description")
                : descriptionForm && parse(descriptionForm)}
            </p>
          </div>
        </div>
      ) : (
        <>
          <div className="title-form">
            {titleForm && (
              <h2
                style={{ direction: contains_heb(titleForm) }}
                className={`${
                  titleForm.length > 26
                    ? "above26"
                    : titleForm.length > 15
                    ? "above20"
                    : titleForm.length > 12
                    ? "above15"
                    : titleForm.length > 10
                    ? "above10"
                    : ""
                }`}
              >
                {demoPageId > 0
                  ? getTextByKey("default-title")
                  : parse(titleForm)}
              </h2>
            )}
          </div>
          <div className="form-image">
            <Image src={formImage} alt="" title="" />
          </div>
          <div className="form-description">
            <p style={{ direction: contains_heb(descriptionForm) }}>
              {demoPageId > 0
                ? getTextByKey("default-description")
                : descriptionForm && parse(descriptionForm)}
            </p>
          </div>
        </>
      )}
    </>
  );
};

export default FormPreviewSide;
